export default __webpack_public_path__ + "static/media/Bloodtrail Sabatons.9efb4f0f.jpg";